module.exports = {
      id: "mail-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#mail",
      toString: function () {
        return this.url;
      }
    }